module.exports = __webpack_public_path__ + "img/1f421.1d8ac81.svg";